import config from "@Config/index";

const currencyData = [
  {
    standard_name: "USD",
    short_name: "dollar",
    symbol: "$",
    full_name: "Dollar ($)",
    countries: ["united states", "usa"],
  },
  {
    standard_name: "GBP",
    short_name: "pound",
    symbol: "£",
    full_name: "Pound (£)",
    countries: ["united kingdom", "uk"],
  },
  {
    standard_name: "EUR",
    short_name: "euro",
    symbol: "€",
    full_name: "Euro (€)",
    countries: ["netherlands", "ireland", "spain", "germany", "italy", "france", "portugal"],
  },
  {
    standard_name: "CNY",
    short_name: "cny",
    symbol: "¥",
    full_name: "Chinese Yuan (¥)",
    countries: ["china"],
  },
  {
    standard_name: "CAD",
    short_name: "cad",
    symbol: "CA$",
    full_name: "Canadian Dollar (Ca$)",
    countries: ["canada"],
  },
  {
    standard_name: "INR",
    short_name: "inr",
    symbol: "₹",
    full_name: "Indian Rupee (₹)",
    countries: ["india"],
  },
  {
    standard_name: "AUD",
    short_name: "aud",
    symbol: "AU$",
    full_name: "Australian Dollar (Au$)",
    countries: ["australia"],
  },
  {
    standard_name: "AED",
    short_name: "aed",
    symbol: "AED",
    full_name: "UAE Dirham (AED)",
    countries: ["united arab emirates"],
  },
  {
    standard_name: "SGD",
    short_name: "sgd",
    symbol: "S$",
    full_name: "Singapore Dollar (S$)",
    countries: ["singapore"],
  },
  {
    standard_name: "NZD",
    short_name: "nzd",
    symbol: "NZ$",
    full_name: "New Zealand Dollar (NZ$)",
    countries: ["new zealand"],
  },
  {
    standard_name: "KRW",
    short_name: "krw",
    symbol: "₩",
    full_name: "Korean Won (₩)",
    countries: ["south korea"],
  },
  {
    standard_name: "DKK",
    short_name: "dkk",
    symbol: "DKK",
    full_name: "Danish Krone (DKK)",
    countries: ["denmark"],
  },
  {
    standard_name: "HKD",
    short_name: "hkd",
    symbol: "HK$",
    full_name: "Hong Kong Dollar (HK$)",
    countries: ["hong kong"],
  },
  {
    standard_name: "TWD",
    short_name: "twd",
    symbol: "NT$",
    full_name: "New Taiwan Dollar (NT$)",
    countries: ["taiwan"],
  },
  // MENA display currencies (P1D-5557). Properties are never priced in these, so `countries`
  // stays empty: getCurrencyFromRegion substring-matches it ("oman" is inside "romania").
  {
    standard_name: "SAR",
    short_name: "sar",
    symbol: "SAR",
    full_name: "Saudi Riyal (SAR)",
    countries: [],
  },
  {
    standard_name: "KWD",
    short_name: "kwd",
    symbol: "KWD",
    full_name: "Kuwaiti Dinar (KWD)",
    countries: [],
  },
  {
    standard_name: "QAR",
    short_name: "qar",
    symbol: "QAR",
    full_name: "Qatari Riyal (QAR)",
    countries: [],
  },
  {
    standard_name: "BHD",
    short_name: "bhd",
    symbol: "BHD",
    full_name: "Bahraini Dinar (BHD)",
    countries: [],
  },
  {
    standard_name: "OMR",
    short_name: "omr",
    symbol: "OMR",
    full_name: "Omani Rial (OMR)",
    countries: [],
  },
  {
    standard_name: "JOD",
    short_name: "jod",
    symbol: "JOD",
    full_name: "Jordanian Dinar (JOD)",
    countries: [],
  },
  {
    standard_name: "ILS",
    short_name: "ils",
    symbol: "₪",
    full_name: "Israeli New Shekel (₪)",
    countries: [],
  },
  {
    standard_name: "TRY",
    short_name: "try",
    symbol: "₺",
    full_name: "Turkish Lira (₺)",
    countries: [],
  },
  {
    standard_name: "EGP",
    short_name: "egp",
    symbol: "EGP",
    full_name: "Egyptian Pound (EGP)",
    countries: [],
  },
  {
    standard_name: "MAD",
    short_name: "mad",
    symbol: "MAD",
    full_name: "Moroccan Dirham (MAD)",
    countries: [],
  },
  {
    standard_name: "DZD",
    short_name: "dzd",
    symbol: "DZD",
    full_name: "Algerian Dinar (DZD)",
    countries: [],
  },
  {
    standard_name: "TND",
    short_name: "tnd",
    symbol: "TND",
    full_name: "Tunisian Dinar (TND)",
    countries: [],
  },
];

const BASE_CURRENCY_CODES = [
  "USD",
  "GBP",
  "EUR",
  "CNY",
  "CAD",
  "INR",
  "AUD",
  "AED",
  "SGD",
  "NZD",
  "KRW",
  "DKK",
  "HKD",
  "TWD",
];

// Switch-off: empty this list. The entries above stay, so a visitor whose cookie already holds
// one of these codes still gets its symbol.
const MENA_CURRENCY_CODES = [
  "SAR",
  "KWD",
  "QAR",
  "BHD",
  "OMR",
  "JOD",
  "ILS",
  "TRY",
  "EGP",
  "MAD",
  "DZD",
  "TND",
];

// The China build keeps today's list.
const ALLOWED_CURRENCY_CODES =
  config.IS_CHINA_APP || config.IS_CHINA_ARTIFACT
    ? BASE_CURRENCY_CODES
    : [...BASE_CURRENCY_CODES, ...MENA_CURRENCY_CODES];

export default currencyData;
export { ALLOWED_CURRENCY_CODES, BASE_CURRENCY_CODES, MENA_CURRENCY_CODES };
